/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Folder_CreatedInputs */

const en_toast_folder_created = /** @type {(inputs: Toast_Folder_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder created`)
};

const es_toast_folder_created = /** @type {(inputs: Toast_Folder_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta creada`)
};

/**
* | output |
* | --- |
* | "Folder created" |
*
* @param {Toast_Folder_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_folder_created = /** @type {((inputs?: Toast_Folder_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Folder_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_folder_created(inputs)
	return en_toast_folder_created(inputs)
});